import {appComponent} from '../app.component';
import {BrowseSidebarComponent} from '../search/browse-sidebar/browse-sidebar.component';
import {registerComponent} from '../../shared/react/registrar';
import {SearchPage} from '../../shared/search/search-result/SearchPage';

new BrowseSidebarComponent(appComponent.sessionStorageService);
registerComponent(SearchPage, `SearchPage`);
